// From here: https://stackoverflow.com/questions/58767980/aws-cognito-password-regex-specific-to-aws-cognito
// const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()\\?\-"“!+=@#%&/,><’:;|_~`])\S{8,99}$/;

const isValidPassword = (text: string): boolean => {
  return passwordRegex.test(text);
};

export default isValidPassword;
